import { Alert, Snackbar } from "@mui/material";
import { useGlobalState } from "../../../context/AppContext";

interface Props {
  children?: React.ReactElement<unknown>
}

export default function NoticeAlert(props: Props) {
  /** グローバルステート */
  const { state, setState } = useGlobalState()
  /** 閉じる処理 */
  const handleClose = () => {
    setState({
      ...state,
      alert: {
        ...state.alert,
        isOpen: false
      }
    })
  }
  return (
    <Snackbar
      open={state.alert.isOpen}
      autoHideDuration={state.alert.autoHideDuration}
      onClose={handleClose}
      anchorOrigin={state.alert.anchorOrigin}
    >
      <Alert
        onClose={handleClose}
        severity={state.alert.severity}
        variant="filled"
      >
        {state.alert.message}
      </Alert>
    </Snackbar >
  )
}